module.exports = __webpack_public_path__ + "img/Recruitment.04a248f6.png";